import { useRouter } from "next/router";

/**
 * Chek if there is a specific url parameter
 */
export const useHasUrlParameter = (parameterKey: string): boolean => {
  const router = useRouter();
  return Object.prototype.hasOwnProperty.call(router.query, parameterKey);
};
